import { ACTION_TYPES } from '@/actions';

const INIT_STATE = {
  auditInfo: {}
};

export default function visaUploadFiles(state = INIT_STATE, action) {
  let result = { ...state };
  const { type, payload } = action;
  switch (type) {
    // 获取签证订单预审材料
    case ACTION_TYPES.GET_VISA_AUDIT_MATERIAL_INFO:
      result.auditInfo = payload;
      break;
    default:
      result = state;
  }
  return result;
}
